import { Directive, ElementRef, Input, HostListener } from '@angular/core';



@Directive({
  selector: '[AlphabetswithspecialDirective]'
})
export class AlphabetswithspecialDirective {

  @Input("AlphabetswithspecialDirective") mystyle: any;
  constructor(private el: ElementRef) {
    el.nativeElement.onkeypress = function (e) {
      console.log(e);
      if (String.fromCharCode(e.keyCode).match(/[^A-Za-z0-9!@#$%^&*()-+_.,'":~-]/g)) {
        e.preventDefault();
        return;
      }
    };
  }

}
